/*jshint esversion: 6 */
import SideMenu from './SideMenu.js';
import React, { Component } from 'react';

import BigLogo from '../Templates/BigLogo.js';
import SmallLogo from '../Templates/SmallLogo.js';
import * as renderer from "../utils/Renderer.js";
import * as strFuncs from "../utils/stringFuncs.js";
import '../css/utils.css';

class PageDisplayer extends Component {
  constructor(props){
    super(props);
    this.state = {
      pageData: {},
      isMobileToggleOn: false
    };
    
  }

  componentWillMount(){
  }

 


  render() {
    let screenHeight = window.screen.height;
    //console.log("screenHeight", screenHeight);
    //console.log('PAGEDISPLAYER this.props.pagetitles', this.props.pagetitles);
    //console.log('PAGEDISPLAYER RENDER this.props', this.props);
    let pageObject = this.props.pageObject;
    let pageIsAvaleht = false;
    
    if(pageObject){
      pageIsAvaleht = pageObject.isAvaleht;
    }
    let noSideMenuPageClassName = pageIsAvaleht? '' : 'no_side_menu';

    //console.log('PAGEDISPLAYER pageObject', pageObject);
    const comps = renderer.renderPage(pageObject);
    //console.log("COMPS", comps);
    var subPageObjectsDisplay = {};
    let subrows = [];
    if(pageObject.subPageObjects){
      //console.log("if(pageObject.subPageObjects)");
      if(pageObject.subPageObjects.length){
        //console.log("if(pageObject.subPageObjects.length)");
        pageObject.subPageObjects.forEach((spo, sin) =>{
          //console.log("if(pageObject.subPageObjects.length spo)", spo);
          let urlifiedTitle = strFuncs.replaceSymbols(spo.pagetitle);
          subrows.push(
            <div key = {sin} id={urlifiedTitle} name={urlifiedTitle} className = "submenu_container">
                <br />
                <div className ="submenu_header">{spo.pagetitle.toUpperCase()}</div>
                <div className ="large_container">{renderer.renderPage(spo, true)}</div>
            </div>
          )
        })
      }
    }
    //console.log("subPageObjectsDisplay", subPageObjectsDisplay);
    // const subKeys = Object.keys(subPageObjectsDisplay);
    // console.log("subKeys", subKeys);

    let sideMenu = null;
    if(pageObject.subPageObjects){
      if(pageObject.subPageObjects.length){
        sideMenu = 
          <SideMenu
            subPageObjects = {pageObject.subPageObjects}
            pagetitles = {this.props.pagetitles}
            pageObject = {pageObject}
          />
      }
    }
    return (
      <div className="keskkoht" style={{minHeight: screenHeight + 'px'}}>
          
      {!pageIsAvaleht? 
          <div media="(max-width: 550px)" className="media550">
            <SmallLogo />
          </div>
       :''}

        {sideMenu? 
          <div className="withSidemenu large_container">
            {sideMenu }

            <div className="withSidemenuRightMenu">
            {comps}
            </div>

          </div>

            : 
        
          <div className="large_container">
            {pageIsAvaleht? 
              <div media="(min-width: 550px)">
                <BigLogo />
              </div>
              :
             ''
              
            }
            <div className={noSideMenuPageClassName}>
                {comps}
            </div>

          </div>
        }

        <div>
              <div className="all_subpages_container">
                <div>{subrows}</div>
              </div>
          
        </div>
      </div>
    );
  }
}

export default PageDisplayer;


// WEBPACK FOOTER //
// ./src/Components/PageDisplayer.js